import type { ColumnDef } from '@tanstack/react-table';

export function createIDColumn<T>(): ColumnDef<T> {
  return {
    accessorKey: 'ID',
    header: '#',
    size: 40,
    cell: (row) => (
      <div className="flex w-full min-w-20 items-center justify-center font-roboto text-sm font-normal">
        {row.row.index + 1}
      </div>
    ),
  };
}
